const ACF = {
  is_preview: false,
};

export default ACF;
